import type { QueryClient } from "@tanstack/react-query";

import type { SendMessageResult } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

import { validateAndCancelIfNeeded } from "../../queries/utils";
import type { ThreadOptions } from "../../services/thread/types";

/**
 * Higher-order function that wraps an effect with thread validation and query cancellation
 */
export const withThreadValidation = <T extends SendMessageResult | undefined>(
    effectFn: (threadId: string) => T | Promise<T>,
    options?: ThreadOptions,
) => {
    return async (queryClient: QueryClient): Promise<T | SendMessageResult> => {
        const validationResult = await validateAndCancelIfNeeded(queryClient, options);

        if (!validationResult.success) {
            return { success: false } as T;
        }

        return effectFn(validationResult.threadId);
    };
};
